import {
  createFileRoute,
  Navigate,
  Outlet,
  useRouterState,
} from "@tanstack/react-router";
import React from "react";
import { Box } from "@salestrak/ui";

import { useWorkspace } from "#app/lib/data/workspace-context";
import { SalesTrakLoading } from "#app/components/brand/salestrak-logo";

function AppLayout() {
  const { activeWorkspace, isLoading } = useWorkspace();
  const pathname = useRouterState({ select: (s) => s.location.pathname });

  if (isLoading) {
    return (
      <Box fill="flex" align="center" justify="center">
        <SalesTrakLoading />
      </Box>
    );
  }

  if (!activeWorkspace) {
    const lastSegment = pathname.split("/").filter(Boolean).pop();
    if (
      lastSegment !== "workspace-select" &&
      lastSegment !== "workspace-create" &&
      lastSegment !== "admin"
    ) {
      return <Navigate to="/workspace-select" />;
    }
  }

  return <Outlet />;
}

export const Route = createFileRoute("/(app)")({ component: AppLayout });
